import { useTranslation } from "react-i18next";

import { COUNTER_TYPES, MODIFIERS } from "../utils/constants";
import Counter from "./Counter";
import Box from "./ui/Box";

export function CounterBox({
  acceleration,
  counters,
  highlight,
  heroPhase,
  lastLabel,
  logger,
  mods,
  onComplete,
  result,
  siblings,
  title,
  type,
  nextWarning,
  prevWarning,
}) {
  const { t } = useTranslation();
  const rename = (title) =>
    (mods || [])
      .filter((m) => m.action === MODIFIERS.RENAME)
      .reduce(
        (t, mod) => t.replace(mod.targets.replace("*", ""), mod.info),
        title
      );

  const getTitle = () => {
    if (
      counters[0].type === COUNTER_TYPES.HERO &&
      counters[0].aSide === counters[0].bSide
    ) {
      return `${counters[0].name} [${
        counters[0].frontSide ? "Alter-ego" : "Hero"
      }]`;
    }
    return counters[0].name;
  };

  return (
    <Box
      title={t(rename(title || getTitle()))}
      type={type || counters[0].type}
      highlight={highlight}
    >
      {counters.map((counter) => (
        <Counter
          acceleration={acceleration}
          counter={counter}
          heroPhase={heroPhase}
          key={counter.id}
          lastLabel={lastLabel}
          logger={logger}
          mods={mods}
          onComplete={onComplete}
          result={result}
          title={title ? rename(counter.name) : false}
          nextWarning={nextWarning}
          prevWarning={prevWarning}
        />
      ))}
      {siblings.map((counter) => (
        <Counter
          counter={counter}
          onComplete={onComplete}
          heroPhase={heroPhase}
          key={counter.id}
          title={rename(counter.name)}
          logger={logger}
          mods={mods}
          result={result}
        />
      ))}
    </Box>
  );
}
